(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[81711],{

/***/ 73191:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ SeveralBrandsWrapper; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__(60357);
var style_default = /*#__PURE__*/__webpack_require__.n(style);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./src/components/severalbrands/logo/index.tsx


function SeveralBrandsLogo() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "206",
        height: "30",
        fill: "none",
        viewBox: "0 0 206 30",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_1_839)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#351C4F",
                        d: "M22.143 24.508c.248.477.576.861.988 1.156.412.295.89.515 1.447.66a6.724 6.724 0 001.718.216c.403 0 .829-.033 1.288-.099a4.56 4.56 0 001.287-.384 2.82 2.82 0 001.002-.786c.267-.333.403-.759.403-1.274 0-.552-.178-1.002-.529-1.344-.351-.342-.815-.627-1.386-.857-.571-.23-1.222-.43-1.943-.599a52.57 52.57 0 01-2.2-.571 19.958 19.958 0 01-2.234-.703 7.565 7.565 0 01-1.944-1.072 5.074 5.074 0 01-1.386-1.643c-.35-.66-.529-1.457-.529-2.388 0-1.05.225-1.962.675-2.735a6.09 6.09 0 011.76-1.929 7.688 7.688 0 012.458-1.143 10.47 10.47 0 012.749-.37c1.067 0 2.093.118 3.076.356.984.24 1.855.623 2.618 1.157a5.878 5.878 0 011.817 2.046c.449.829.674 1.836.674 3.02h-4.35c-.038-.608-.169-1.114-.384-1.517a2.537 2.537 0 00-.871-.946 3.721 3.721 0 00-1.246-.487 7.804 7.804 0 00-1.53-.145c-.361 0-.727.038-1.087.113a2.96 2.96 0 00-.988.398c-.295.192-.538.43-.73.716-.192.286-.286.646-.286 1.086 0 .398.075.726.23.974.154.248.454.478.898.689.45.21 1.068.421 1.86.627.79.21 1.825.478 3.104.8.379.076.908.216 1.587.417.679.202 1.349.52 2.018.96.67.44 1.246 1.026 1.733 1.76.487.736.73 1.672.73 2.82 0 .936-.182 1.802-.543 2.603-.36.8-.9 1.494-1.616 2.074-.716.581-1.6 1.035-2.66 1.358-1.057.323-2.284.487-3.675.487-1.123 0-2.215-.14-3.277-.416-1.059-.277-1.995-.712-2.805-1.302a6.365 6.365 0 01-1.93-2.262c-.477-.918-.706-2.004-.688-3.259h4.35c0 .689.122 1.27.37 1.747l-.023-.01zM41.194 25.996c.61.59 1.49.885 2.632.885.82 0 1.526-.206 2.116-.613.59-.412.956-.843 1.087-1.302h3.577c-.571 1.775-1.452 3.043-2.632 3.807-1.184.763-2.612 1.142-4.288 1.142-1.162 0-2.215-.187-3.147-.557a6.458 6.458 0 01-2.374-1.587c-.65-.689-1.147-1.508-1.503-2.459-.351-.955-.53-2.004-.53-3.146 0-1.143.183-2.135.544-3.09a7.138 7.138 0 013.933-4.116c.927-.403 1.948-.6 3.076-.6 1.26 0 2.356.244 3.292.73a6.51 6.51 0 012.304 1.963c.6.82 1.035 1.756 1.302 2.805.267 1.048.36 2.144.285 3.291h-10.67c.055 1.316.388 2.271 1.001 2.861l-.005-.014zm4.594-7.782c-.487-.534-1.227-.8-2.215-.8-.65 0-1.19.112-1.615.327-.431.22-.773.492-1.03.815-.258.323-.44.67-.544 1.03-.103.36-.168.688-.187.974h6.607c-.192-1.03-.53-1.812-1.016-2.346zM56.929 29.542L51.867 14.75h4.261l3.119 10.1h.056l3.118-10.1h4.032l-5.006 14.792H56.93zM72.491 25.996c.61.59 1.49.885 2.632.885.82 0 1.526-.206 2.116-.613.59-.412.956-.843 1.087-1.302h3.577c-.571 1.775-1.452 3.043-2.632 3.807-1.184.763-2.612 1.142-4.289 1.142-1.16 0-2.214-.187-3.146-.557a6.459 6.459 0 01-2.374-1.587c-.651-.689-1.147-1.508-1.503-2.459-.351-.955-.53-2.004-.53-3.146 0-1.143.183-2.135.544-3.09a7.14 7.14 0 013.933-4.116c.927-.403 1.948-.6 3.076-.6 1.26 0 2.356.244 3.292.73a6.51 6.51 0 012.304 1.963c.6.82 1.035 1.756 1.301 2.805.267 1.048.361 2.144.286 3.291H71.494c.056 1.316.389 2.271 1.002 2.861l-.005-.014zm4.594-7.782c-.487-.534-1.227-.8-2.215-.8-.65 0-1.19.112-1.615.327-.431.22-.773.492-1.03.815-.258.323-.44.67-.544 1.03-.103.36-.168.688-.187.974h6.607c-.192-1.03-.53-1.812-1.016-2.346zM88.427 14.75v2.748h.056a5.09 5.09 0 011.887-2.276 5.55 5.55 0 011.344-.646c.478-.154.974-.23 1.489-.23.267 0 .562.047.885.146v3.778a8.094 8.094 0 00-.688-.098 7.383 7.383 0 00-.773-.042c-.744 0-1.372.127-1.887.37a3.253 3.253 0 00-1.245 1.016c-.314.43-.539.932-.675 1.503a8.05 8.05 0 00-.201 1.859v6.668h-4.064V14.754h3.863l.009-.005zM95.52 19.3c.057-.954.296-1.746.717-2.373a4.956 4.956 0 011.601-1.517 6.934 6.934 0 012.187-.815c.81-.16 1.625-.243 2.444-.243.745 0 1.499.051 2.262.159a6.856 6.856 0 012.088.613c.628.304 1.143.73 1.545 1.274.403.543.6 1.264.6 2.158v7.698c0 .67.037 1.307.112 1.915.075.609.211 1.068.403 1.372h-4.121a5.98 5.98 0 01-.187-.702 6.041 6.041 0 01-.098-.73 5.25 5.25 0 01-2.29 1.4 9.19 9.19 0 01-2.688.402 7.17 7.17 0 01-1.971-.257 4.56 4.56 0 01-1.601-.801 3.703 3.703 0 01-1.073-1.372c-.257-.553-.384-1.213-.384-1.976 0-.838.146-1.531.445-2.074a3.727 3.727 0 011.143-1.302 5.219 5.219 0 011.601-.73c.6-.164 1.208-.29 1.817-.384a31.554 31.554 0 011.803-.23 11.03 11.03 0 001.573-.257c.459-.113.819-.281 1.086-.501.267-.22.389-.539.37-.96 0-.44-.07-.787-.215-1.044a1.565 1.565 0 00-.572-.6 2.196 2.196 0 00-.828-.285 6.936 6.936 0 00-1.016-.07c-.801 0-1.429.173-1.887.514-.46.342-.726.918-.801 1.719H95.52zm9.384 3.007a1.794 1.794 0 01-.646.356c-.258.084-.534.159-.829.215-.295.056-.604.103-.932.145a14.43 14.43 0 00-.974.146 7.467 7.467 0 00-.899.229 2.71 2.71 0 00-.772.384c-.22.164-.394.365-.53.613-.135.248-.2.562-.2.946 0 .384.065.67.2.918.136.248.314.445.544.585.229.145.496.244.801.3.304.056.618.084.945.084.801 0 1.419-.131 1.859-.398.44-.267.764-.585.974-.96.211-.37.337-.749.384-1.128.047-.38.07-.689.07-.918v-1.517h.005zM116.291 9.117v20.425h-4.064V9.117h4.064z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#EF4F80",
                        d: "M128.65 9.116c.857 0 1.681.08 2.477.244.791.164 1.489.44 2.088.829.6.388 1.082.903 1.447 1.545.361.636.543 1.432.543 2.388 0 .534-.084 1.053-.257 1.559a4.774 4.774 0 01-.731 1.372 4.615 4.615 0 01-1.114 1.044 4.151 4.151 0 01-1.442.6v.056c1.315.173 2.364.711 3.146 1.615.782.908 1.171 2.027 1.171 3.362 0 .323-.028.693-.084 1.1a5.57 5.57 0 01-.342 1.26 5.29 5.29 0 01-.745 1.273c-.323.422-.758.787-1.301 1.1-.544.314-1.213.572-2.005.773-.791.202-1.741.3-2.846.3h-8.639V9.116h8.639-.005zm0 8.953c.782 0 1.461-.089 2.032-.272.571-.182 1.049-.43 1.433-.744a3.07 3.07 0 00.857-1.1 3.19 3.19 0 00.285-1.344c0-2.557-1.535-3.835-4.607-3.835h-6.696v7.295h6.696zm0 9.814c.726 0 1.409-.06 2.06-.187a4.66 4.66 0 001.719-.674 3.415 3.415 0 001.17-1.302c.286-.543.431-1.227.431-2.046 0-1.316-.464-2.304-1.386-2.96-.922-.655-2.257-.987-3.989-.987h-6.696v8.151h6.696l-.005.005zM140.404 14.777v3.46h.057c.458-1.203 1.166-2.125 2.13-2.776.965-.646 2.112-.946 3.446-.885v1.803c-.819-.038-1.564.07-2.233.328a5.07 5.07 0 00-1.733 1.1 4.952 4.952 0 00-1.128 1.704 5.692 5.692 0 00-.398 2.159v7.866h-1.803V14.773h1.658l.004.004zM148.133 17.067a4.252 4.252 0 011.246-1.545 5.149 5.149 0 011.844-.885c.708-.192 1.489-.285 2.346-.285.647 0 1.297.06 1.944.187a4.711 4.711 0 011.746.702c.515.342.932.824 1.26 1.447.323.618.487 1.428.487 2.416v7.838c0 .726.351 1.087 1.058 1.087.211 0 .402-.038.571-.113v1.517a9.74 9.74 0 01-.557.085 5.526 5.526 0 01-.614.028c-.458 0-.824-.061-1.1-.187a1.435 1.435 0 01-.641-.53 1.948 1.948 0 01-.3-.814 7.069 7.069 0 01-.07-1.044h-.056c-.324.477-.656.899-.988 1.273-.333.37-.708.684-1.115.932a5.07 5.07 0 01-1.4.571c-.524.131-1.147.202-1.873.202a7.28 7.28 0 01-1.929-.244 4.412 4.412 0 01-1.573-.772c-.45-.352-.801-.801-1.058-1.344-.258-.543-.384-1.19-.384-1.93 0-1.03.229-1.835.688-2.416.459-.58 1.063-1.025 1.817-1.33.753-.304 1.601-.52 2.547-.64a219.09 219.09 0 012.875-.357 9.33 9.33 0 001.002-.145c.285-.056.524-.16.716-.3.192-.145.337-.337.445-.585.103-.248.159-.571.159-.974 0-.608-.098-1.11-.299-1.503a2.428 2.428 0 00-.829-.932 3.294 3.294 0 00-1.232-.473 8.489 8.489 0 00-1.503-.126c-1.142 0-2.079.272-2.804.815-.726.543-1.105 1.414-1.143 2.617h-1.803c.057-.857.239-1.601.544-2.233l-.024-.01zm9.014 4.407c-.113.21-.333.36-.661.458a6.839 6.839 0 01-.856.202c-.764.136-1.55.253-2.36.355-.81.104-1.55.263-2.22.473-.669.211-1.217.51-1.643.9-.431.393-.646.95-.646 1.671 0 .459.089.862.271 1.217.183.352.426.66.731.918.304.258.66.454 1.058.585.402.136.81.202 1.231.202.689 0 1.344-.103 1.976-.314a4.865 4.865 0 001.644-.918 4.366 4.366 0 001.114-1.46c.276-.576.417-1.223.417-1.944v-2.345h-.056zM164.381 14.778v2.547h.056c.342-.895.955-1.615 1.831-2.159a5.375 5.375 0 012.889-.814c1.049 0 1.892.135 2.589.398.698.267 1.255.646 1.672 1.128.421.487.716 1.082.885 1.789.173.707.257 1.498.257 2.374v9.495h-1.802v-9.21a8.38 8.38 0 00-.174-1.76 3.662 3.662 0 00-.599-1.414 2.963 2.963 0 00-1.157-.946c-.486-.23-1.091-.342-1.816-.342-.726 0-1.368.126-1.929.384a4.146 4.146 0 00-1.429 1.058c-.393.45-.697.983-.917 1.601a6.498 6.498 0 00-.356 2.019v8.61h-1.803V14.774h1.803v.005zM189.299 29.54v-2.804h-.057a4.255 4.255 0 01-.842 1.316c-.37.402-.796.74-1.274 1.016a6.504 6.504 0 01-1.531.641 5.881 5.881 0 01-1.616.23c-1.123 0-2.102-.206-2.931-.614a5.852 5.852 0 01-2.074-1.69 7.234 7.234 0 01-1.231-2.491 10.93 10.93 0 01-.403-2.988c0-1.048.131-2.046.403-2.987a7.233 7.233 0 011.231-2.49 6.042 6.042 0 012.074-1.705c.829-.422 1.808-.628 2.931-.628.553 0 1.091.066 1.616.202a5.528 5.528 0 011.475.613 5.17 5.17 0 011.217 1.016c.351.398.623.866.815 1.4h.056V9.111h1.803v20.425h-1.658l-.004.005zm-9.885-5.108c.183.754.468 1.428.857 2.018.389.59.89 1.072 1.503 1.442.609.37 1.344.558 2.201.558.955 0 1.76-.188 2.416-.558a4.805 4.805 0 001.601-1.442 5.83 5.83 0 00.885-2.018 9.611 9.611 0 000-4.551 6.024 6.024 0 00-.885-2.018 4.806 4.806 0 00-1.601-1.442c-.66-.37-1.466-.558-2.416-.558-.857 0-1.592.188-2.201.558-.609.37-1.11.852-1.503 1.442a6.163 6.163 0 00-.857 2.018 9.662 9.662 0 000 4.551zM202.889 17.657a2.936 2.936 0 00-.843-1.016 3.454 3.454 0 00-1.217-.585 5.675 5.675 0 00-1.461-.188c-.403 0-.806.042-1.218.127-.412.084-.786.23-1.128.43a2.472 2.472 0 00-.829.787c-.21.323-.314.726-.314 1.204 0 .402.099.74.3 1.016.202.276.454.51.759.702.304.192.637.346 1.002.473.36.126.697.225 1.002.3l2.402.543a6.772 6.772 0 011.531.416c.506.202.955.464 1.344.787.388.323.712.726.96 1.203.248.478.37 1.04.37 1.69 0 .801-.183 1.485-.544 2.047a4.4 4.4 0 01-1.386 1.372 5.975 5.975 0 01-1.901.758c-.707.155-1.4.23-2.088.23-1.737 0-3.142-.412-4.219-1.232-1.077-.819-1.695-2.135-1.845-3.947h1.803c.075 1.222.52 2.14 1.33 2.763.81.618 1.817.932 3.02.932.44 0 .89-.047 1.358-.146a4.32 4.32 0 001.302-.487c.402-.229.73-.52.988-.87.257-.352.384-.787.384-1.302 0-.44-.089-.806-.272-1.1a2.412 2.412 0 00-.73-.745 4.703 4.703 0 00-1.045-.501 12.734 12.734 0 00-1.189-.342l-2.318-.515a13.312 13.312 0 01-1.629-.529 5.221 5.221 0 01-1.302-.744 3.118 3.118 0 01-.871-1.087c-.211-.43-.314-.96-.314-1.587 0-.745.169-1.381.501-1.915a3.894 3.894 0 011.302-1.288 6.123 6.123 0 011.789-.716 8.562 8.562 0 011.962-.23c.744 0 1.433.094 2.074.286a4.857 4.857 0 011.69.885c.487.398.871.899 1.157 1.489.286.59.449 1.288.487 2.088h-1.803c-.019-.552-.136-1.035-.342-1.447l-.009-.01zM0 6.026l4.205 2.21L19.212 1.47 5.975 9.374l7.576 4.06L21.427 0 0 6.026z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#351C4F",
                        d: "M4.344 15.016l4.715-3.282L5.49 9.828l-1.147 5.188z"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_1_839",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0H205.547V30H0z"
                    })
                })
            })
        ]
    });
}
/* harmony default export */ var logo = (SeveralBrandsLogo);

// EXTERNAL MODULE: ./src/components/severalbrands/header/style.module.scss
var style_module = __webpack_require__(66257);
var style_module_default = /*#__PURE__*/__webpack_require__.n(style_module);
;// CONCATENATED MODULE: ./src/components/severalbrands/header/burger.tsx



function Burger({ isOpened , setOpened  }) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: `${(style_module_default()).burger} ${isOpened ? `${(style_module_default()).open} fixed` : ""}`,
        onClick: ()=>setOpened(!isOpened),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
        ]
    });
}

// EXTERNAL MODULE: ./src/hooks/useWindowSize.tsx
var useWindowSize = __webpack_require__(91173);
;// CONCATENATED MODULE: ./src/components/severalbrands/header/index.tsx






function SeveralBrandsHeader({ domain , hideMenu =false  }) {
    const { 0: isOpened , 1: setOpened  } = (0,react.useState)(false);
    const windowSize = (0,useWindowSize/* default */.Z)();
    const listPages = domain?.menus ? domain?.menus.find((menu)=>menu.slug === "severalbrands-header")?.links : domain.menusList?.find((menu)=>menu.slug === "severalbrands-header")?.items;
    const { 0: isSticky , 1: setIsSticky  } = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        const handleScroll = ()=>{
            if (windowSize.width < 767) {
                if (window.scrollY >= 15) {
                    setIsSticky(true);
                } else {
                    setIsSticky(false);
                }
            } else {
                if (window.scrollY >= 83) {
                    setIsSticky(true);
                } else {
                    setIsSticky(false);
                }
            }
        };
        window.addEventListener("scroll", handleScroll);
        // Cleanup event listener on component unmount
        return ()=>{
            window.removeEventListener("scroll", handleScroll);
        };
    }, [
        windowSize
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
        id: "headerId",
        className: `md:mt-[60px] mt-[15px]  px-4 z-100  ${(style_module_default()).stickyStyle} ${isSticky ? (style_module_default()).stickyStyleAfter : ""}`,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: " flex lg:max-w-7xl 3xl:max-w-[120rem] mx-auto justify-between relative ",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "logo",
                    style: {
                        backgroundImage: `url(${domain?.logo?.fullPath ?? ""})`,
                        width: "auto",
                        height: "auto",
                        backgroundSize: "contain",
                        backgroundRepeat: "no-repeat",
                        backgroundPosition: "center"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: hideMenu ? undefined : "/",
                        "aria-label": `${domain?.name} logo`,
                        children: domain?.logo?.fullPath ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: domain?.logo?.fullPath,
                            className: "w-full h-auto lg:h-10 3xl:h-12",
                            alt: `${domain?.name} logo`,
                            style: {
                                visibility: "hidden"
                            }
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "children:w-full children:h-auto lg:children:h-10 3xl:children:h-12",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(logo, {})
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: `${(style_module_default()).burger} ${isOpened ? (style_module_default()).openBurger : ""}`,
                    children: !hideMenu && /*#__PURE__*/ (0,jsx_runtime.jsx)(Burger, {
                        isOpened: isOpened,
                        setOpened: (x)=>{
                            setOpened(x);
                        }
                    })
                }),
                !hideMenu && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: isOpened ? `${(style_module_default()).menu} ${(style_module_default()).open}` : (style_module_default()).menuItem,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (style_module_default()).innerDiv,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                children: "Menu"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (style_module_default()).allMenu,
                                children: listPages?.map((page)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "block my-3 w-fit hover:underline mx-auto md:mx-0",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: page.link,
                                            children: page.title
                                        })
                                    }, page.link))
                            })
                        ]
                    })
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./src/components/severalbrands/footer/footerLogo/index.tsx


function FooterLogo() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        height: "100%",
        fill: "none",
        viewBox: "0 0 309 45",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_418_3597)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#37367D",
                        d: "M33.214 36.763a4.823 4.823 0 001.482 1.735c.618.442 1.335.772 2.17.99.83.218 1.686.323 2.578.323.604 0 1.243-.05 1.932-.148a6.84 6.84 0 001.931-.576 4.228 4.228 0 001.503-1.18c.4-.498.604-1.137.604-1.91 0-.829-.267-1.503-.794-2.016-.526-.512-1.222-.94-2.078-1.285a20.182 20.182 0 00-2.915-.899 79.017 79.017 0 01-3.301-.857 29.945 29.945 0 01-3.35-1.053 11.348 11.348 0 01-2.915-1.609 7.612 7.612 0 01-2.08-2.465c-.526-.99-.793-2.184-.793-3.582 0-1.573.337-2.943 1.011-4.102a9.137 9.137 0 012.641-2.894c1.089-.772 2.318-1.341 3.688-1.713a15.702 15.702 0 014.122-.555c1.602 0 3.14.175 4.615.534 1.475.358 2.781.934 3.926 1.734a8.818 8.818 0 012.725 3.07c.675 1.243 1.012 2.753 1.012 4.53h-6.525c-.056-.913-.253-1.672-.576-2.276a3.806 3.806 0 00-1.307-1.419c-.54-.344-1.166-.582-1.868-.73a11.7 11.7 0 00-2.297-.218c-.54 0-1.088.056-1.629.169-.54.112-1.04.316-1.482.597a3.806 3.806 0 00-1.096 1.075c-.288.428-.428.969-.428 1.629 0 .597.112 1.089.344 1.46.232.373.681.717 1.349 1.033.674.316 1.6.633 2.788.941 1.187.317 2.74.717 4.657 1.201.569.113 1.362.324 2.38.626 1.019.302 2.023.78 3.028 1.44 1.004.66 1.868 1.538 2.598 2.64.73 1.103 1.096 2.508 1.096 4.228 0 1.405-.274 2.705-.815 3.906-.54 1.2-1.348 2.24-2.423 3.111-1.074.871-2.402 1.552-3.99 2.037-1.587.485-3.427.73-5.513.73-1.685 0-3.322-.21-4.916-.625-1.587-.414-2.992-1.067-4.207-1.952a9.55 9.55 0 01-2.894-3.393c-.716-1.376-1.06-3.006-1.032-4.888h6.524c0 1.032.183 1.903.555 2.62l-.035-.014zM61.792 38.996c.913.886 2.233 1.328 3.947 1.328 1.23 0 2.29-.309 3.175-.92.885-.618 1.432-1.264 1.63-1.953h5.365c-.857 2.662-2.177 4.566-3.947 5.71-1.777 1.145-3.92 1.714-6.434 1.714-1.742 0-3.322-.28-4.72-.836-1.404-.554-2.591-1.348-3.56-2.38-.977-1.033-1.721-2.262-2.255-3.688-.527-1.433-.794-3.006-.794-4.72 0-1.713.274-3.202.815-4.635.54-1.433 1.313-2.67 2.318-3.709a10.876 10.876 0 013.582-2.465c1.39-.604 2.922-.899 4.614-.899 1.89 0 3.533.365 4.938 1.096 1.405.73 2.556 1.706 3.455 2.942.9 1.23 1.553 2.634 1.953 4.208.4 1.573.54 3.216.428 4.937H60.296c.084 1.974.583 3.407 1.503 4.292l-.007-.022zm6.89-11.673c-.73-.8-1.84-1.2-3.322-1.2-.977 0-1.784.168-2.423.491-.647.33-1.16.738-1.546 1.222a4.44 4.44 0 00-.814 1.545 7.154 7.154 0 00-.281 1.461h9.91c-.288-1.545-.794-2.718-1.524-3.519zM85.393 44.313l-7.592-22.188h6.391l4.678 15.15h.084l4.678-15.15h6.047l-7.508 22.188h-6.778zM108.737 38.996c.913.886 2.234 1.328 3.947 1.328 1.229 0 2.29-.309 3.175-.92.885-.618 1.433-1.264 1.629-1.953h5.366c-.856 2.662-2.177 4.566-3.947 5.71-1.777 1.145-3.919 1.714-6.433 1.714-1.742 0-3.323-.28-4.72-.836-1.405-.554-2.592-1.348-3.561-2.38-.977-1.033-1.721-2.262-2.255-3.688-.527-1.433-.793-3.006-.793-4.72 0-1.713.273-3.202.814-4.635.541-1.433 1.314-2.67 2.318-3.709a10.868 10.868 0 013.582-2.465c1.391-.604 2.922-.899 4.615-.899 1.889 0 3.532.365 4.937 1.096 1.405.73 2.557 1.706 3.456 2.942.899 1.23 1.552 2.634 1.952 4.208.401 1.573.541 3.216.429 4.937h-16.007c.084 1.974.583 3.407 1.503 4.292l-.007-.022zm6.89-11.673c-.73-.8-1.84-1.2-3.322-1.2-.976 0-1.784.168-2.423.491-.646.33-1.159.738-1.545 1.222a4.42 4.42 0 00-.815 1.545 7.115 7.115 0 00-.281 1.461h9.91c-.288-1.545-.793-2.718-1.524-3.519zM132.641 22.125v4.123h.084a7.626 7.626 0 011.159-1.91 7.71 7.71 0 011.671-1.503 8.337 8.337 0 012.016-.97 7.21 7.21 0 012.234-.343c.4 0 .842.07 1.327.217v5.668a12.126 12.126 0 00-1.032-.147 11.103 11.103 0 00-1.159-.064c-1.117 0-2.058.19-2.831.555-.772.373-1.398.878-1.868 1.524-.471.647-.808 1.398-1.011 2.255a12.058 12.058 0 00-.303 2.788V44.32h-6.096V22.132h5.794l.015-.007zM143.283 28.951c.084-1.433.442-2.62 1.074-3.56a7.44 7.44 0 012.403-2.276 10.392 10.392 0 013.28-1.222 18.974 18.974 0 013.666-.366c1.117 0 2.247.078 3.392.24 1.145.154 2.192.463 3.133.92a6.218 6.218 0 012.317 1.91c.605.814.9 1.896.9 3.237v11.547c0 1.005.056 1.96.168 2.873.112.913.316 1.601.604 2.058h-6.181a9.176 9.176 0 01-.281-1.054 9.376 9.376 0 01-.147-1.095 7.86 7.86 0 01-3.435 2.1c-1.313.4-2.662.604-4.031.604-1.061 0-2.044-.127-2.957-.387a6.835 6.835 0 01-2.402-1.2 5.552 5.552 0 01-1.608-2.059c-.387-.828-.576-1.819-.576-2.963 0-1.258.217-2.297.667-3.112.442-.815 1.018-1.468 1.714-1.953a7.822 7.822 0 012.402-1.095 24.432 24.432 0 012.725-.576c.913-.14 1.819-.26 2.704-.344a16.566 16.566 0 002.36-.387c.688-.168 1.229-.421 1.629-.751.401-.33.583-.808.555-1.44 0-.66-.105-1.18-.323-1.566a2.352 2.352 0 00-.857-.9 3.298 3.298 0 00-1.243-.428 10.38 10.38 0 00-1.524-.105c-1.201 0-2.142.26-2.831.773-.688.512-1.088 1.376-1.201 2.577h-6.096zm14.075 4.51c-.26.231-.583.407-.969.533a10.03 10.03 0 01-1.243.323c-.443.084-.906.155-1.398.218-.485.056-.969.126-1.461.218a11.15 11.15 0 00-1.348.344c-.443.14-.829.337-1.159.576-.33.246-.59.548-.794.92-.204.372-.302.843-.302 1.419 0 .576.098 1.004.302 1.376.204.373.471.668.815.878.344.218.744.365 1.201.45.456.084.927.126 1.419.126 1.201 0 2.128-.197 2.788-.597.66-.4 1.145-.878 1.461-1.44a4.547 4.547 0 00.576-1.692c.07-.57.105-1.033.105-1.377V33.46h.007zM174.436 13.676v30.637h-6.096V13.676h6.096z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#EF4F80",
                        d: "M192.975 13.676c1.285 0 2.521.12 3.715.365 1.187.246 2.234.66 3.133 1.243a6.614 6.614 0 012.17 2.318c.541.955.815 2.15.815 3.582 0 .8-.127 1.58-.386 2.339a7.136 7.136 0 01-1.096 2.058 6.957 6.957 0 01-1.672 1.566 6.219 6.219 0 01-2.163.899v.084c1.974.26 3.547 1.068 4.72 2.423 1.173 1.363 1.756 3.042 1.756 5.043 0 .485-.042 1.04-.127 1.65a8.274 8.274 0 01-.512 1.89c-.253.646-.632 1.278-1.117 1.91-.485.633-1.138 1.18-1.953 1.651-.814.47-1.819.857-3.006 1.16-1.187.301-2.613.449-4.27.449h-12.959v-30.63h12.959-.007zm0 13.429c1.173 0 2.191-.134 3.048-.407.857-.274 1.573-.647 2.149-1.117a4.588 4.588 0 001.286-1.65c.288-.633.428-1.3.428-2.017 0-3.834-2.304-5.752-6.911-5.752h-10.044v10.943h10.044zm0 14.721a16.15 16.15 0 003.09-.28c.97-.183 1.833-.52 2.578-1.012a5.137 5.137 0 001.756-1.953c.428-.814.646-1.84.646-3.069 0-1.974-.695-3.456-2.079-4.439-1.384-.983-3.385-1.482-5.984-1.482h-10.044V41.82h10.044l-.007.007zM210.607 22.17v5.19h.084c.688-1.806 1.749-3.19 3.196-4.165 1.447-.97 3.167-1.42 5.169-1.328v2.704c-1.229-.056-2.346.105-3.35.492a7.607 7.607 0 00-2.599 1.65 7.444 7.444 0 00-1.693 2.557c-.4.99-.597 2.065-.597 3.238v11.8h-2.704V22.161h2.487l.007.007zM222.2 25.601a6.382 6.382 0 011.868-2.318c.787-.604 1.707-1.046 2.767-1.327 1.061-.288 2.234-.429 3.519-.429.969 0 1.946.092 2.915.281.969.19 1.847.534 2.62 1.054.772.513 1.397 1.236 1.889 2.17.485.927.73 2.142.73 3.624v11.758c0 1.088.527 1.63 1.588 1.63.316 0 .604-.057.857-.17v2.276c-.316.056-.597.099-.836.127a8.278 8.278 0 01-.92.042c-.689 0-1.236-.092-1.651-.281a2.161 2.161 0 01-.962-.794c-.232-.344-.379-.751-.45-1.222-.07-.47-.105-.99-.105-1.566h-.084a18.56 18.56 0 01-1.482 1.91 7.511 7.511 0 01-1.672 1.398 7.609 7.609 0 01-2.1.857c-.786.197-1.721.302-2.809.302-1.033 0-1.995-.12-2.894-.365a6.62 6.62 0 01-2.36-1.16 5.5 5.5 0 01-1.587-2.015c-.387-.815-.576-1.784-.576-2.894 0-1.545.344-2.753 1.032-3.624.689-.87 1.595-1.538 2.725-1.995 1.131-.456 2.402-.78 3.821-.962a330.42 330.42 0 014.313-.534 13.977 13.977 0 001.503-.217 2.672 2.672 0 001.074-.45c.288-.218.506-.506.668-.878.154-.372.238-.857.238-1.46 0-.914-.147-1.665-.449-2.255a3.63 3.63 0 00-1.243-1.398 4.95 4.95 0 00-1.847-.71 12.728 12.728 0 00-2.255-.189c-1.714 0-3.118.407-4.207 1.222s-1.658 2.121-1.714 3.926h-2.704c.084-1.285.358-2.402.815-3.35l-.035-.014zm13.52 6.61c-.169.315-.499.54-.99.688-.485.14-.913.245-1.286.301-1.144.204-2.324.38-3.539.534a19.138 19.138 0 00-3.33.71c-1.004.316-1.826.765-2.465 1.348-.646.59-.969 1.426-.969 2.508 0 .688.133 1.292.407 1.826.274.527.639.99 1.096 1.376.456.387.99.682 1.587.878a5.719 5.719 0 001.847.302 9.286 9.286 0 002.964-.47 7.302 7.302 0 002.466-1.377 6.55 6.55 0 001.671-2.191c.415-.864.625-1.833.625-2.915V32.21h-.084zM246.571 22.166v3.821h.085c.512-1.341 1.432-2.423 2.746-3.238a8.065 8.065 0 014.333-1.222c1.574 0 2.838.204 3.884.597 1.047.4 1.883.97 2.508 1.693.632.73 1.074 1.622 1.327 2.683.26 1.06.386 2.248.386 3.561v14.244h-2.704V30.489c0-.94-.084-1.826-.259-2.64-.169-.815-.471-1.525-.899-2.122-.429-.597-1.012-1.074-1.735-1.418-.731-.345-1.637-.513-2.725-.513-1.089 0-2.051.19-2.894.576a6.208 6.208 0 00-2.142 1.587c-.59.675-1.047 1.475-1.377 2.402-.33.927-.506 1.939-.534 3.027v12.917h-2.704V22.16h2.704v.006zM283.946 44.314v-4.207h-.084a6.387 6.387 0 01-1.265 1.973 8.032 8.032 0 01-1.91 1.524 9.74 9.74 0 01-2.297.963 8.81 8.81 0 01-2.423.344c-1.685 0-3.153-.31-4.397-.92a8.764 8.764 0 01-3.111-2.536c-.829-1.074-1.447-2.318-1.847-3.736a16.413 16.413 0 01-.604-4.481c0-1.574.196-3.07.604-4.482.4-1.418 1.018-2.661 1.847-3.736a9.052 9.052 0 013.111-2.557c1.244-.632 2.712-.94 4.397-.94.829 0 1.637.098 2.423.301a8.29 8.29 0 012.213.92c.688.415 1.292.92 1.826 1.524.527.598.934 1.3 1.222 2.1h.084V13.67h2.704v30.637h-2.486l-.007.007zm-14.827-7.663c.274 1.13.703 2.142 1.286 3.027a6.988 6.988 0 002.254 2.164c.913.554 2.016.835 3.301.835 1.433 0 2.641-.28 3.624-.835a7.196 7.196 0 002.402-2.164c.619-.885 1.061-1.896 1.328-3.027.274-1.13.407-2.269.407-3.413 0-1.145-.133-2.283-.407-3.414a9.076 9.076 0 00-1.328-3.027 7.196 7.196 0 00-2.402-2.163c-.99-.555-2.198-.836-3.624-.836-1.285 0-2.388.28-3.301.836a7.131 7.131 0 00-2.254 2.163c-.59.885-1.019 1.896-1.286 3.027a14.441 14.441 0 00-.407 3.414c0 1.144.133 2.282.407 3.413zM304.328 26.488a4.396 4.396 0 00-1.265-1.524 5.176 5.176 0 00-1.826-.878 8.507 8.507 0 00-2.191-.28c-.604 0-1.208.063-1.826.189a5.466 5.466 0 00-1.693.646 3.702 3.702 0 00-1.243 1.18c-.316.485-.471 1.089-.471 1.805 0 .604.148 1.11.45 1.524.302.415.681.766 1.138 1.054a7.2 7.2 0 001.503.71c.541.189 1.046.336 1.503.449l3.603.814a10.17 10.17 0 012.297.626 7.434 7.434 0 012.015 1.18 5.8 5.8 0 011.44 1.805c.372.716.555 1.559.555 2.535 0 1.201-.274 2.227-.815 3.07a6.598 6.598 0 01-2.079 2.057c-.842.527-1.798.906-2.851 1.138-1.061.232-2.1.344-3.133.344-2.605 0-4.713-.618-6.328-1.847-1.615-1.23-2.542-3.203-2.767-5.92h2.704c.112 1.832.779 3.209 1.994 4.143 1.216.927 2.726 1.398 4.531 1.398.66 0 1.334-.07 2.037-.218a6.474 6.474 0 001.952-.73 4.68 4.68 0 001.482-1.307c.386-.527.576-1.18.576-1.952 0-.66-.133-1.208-.407-1.65a3.617 3.617 0 00-1.096-1.118 7.047 7.047 0 00-1.566-.751 19.243 19.243 0 00-1.784-.513l-3.477-.773c-.885-.231-1.7-.491-2.444-.793a7.833 7.833 0 01-1.953-1.117 4.675 4.675 0 01-1.306-1.63c-.316-.645-.471-1.44-.471-2.38 0-1.117.253-2.072.752-2.873a5.843 5.843 0 011.952-1.931 9.184 9.184 0 012.683-1.075 12.855 12.855 0 012.943-.344c1.117 0 2.149.14 3.112.428.955.288 1.805.73 2.535 1.328a6.487 6.487 0 011.735 2.233c.428.885.674 1.932.731 3.133h-2.705c-.028-.83-.203-1.552-.512-2.17l-.014-.015zM0 9.04l6.307 3.315 22.51-10.15L8.963 14.061l11.364 6.09L32.14 0 0 9.04z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#37367D",
                        d: "M6.516 22.524l7.072-4.923-5.352-2.859-1.72 7.782z"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_418_3597",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0H308.321V45H0z"
                    })
                })
            })
        ]
    });
}
/* harmony default export */ var footerLogo = (FooterLogo);

;// CONCATENATED MODULE: ./src/components/severalbrands/footer/icons/facebookIcon.tsx


const FacebookIcon = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "42",
        height: "42",
        fill: "none",
        viewBox: "0 0 50 50",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "50",
                height: "50",
                fill: "#36387D",
                rx: "8"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                d: "M38 25.048C38 17.842 32.18 12 25 12s-13 5.842-13 13.048a13.044 13.044 0 0 0 9.86 12.663v-8.676h-2.68v-3.987h2.68V23.33c0-4.441 2.002-6.5 6.346-6.5.824 0 2.245.163 2.826.324v3.615c-.306-.033-.84-.049-1.501-.049-2.132 0-2.955.81-2.955 2.918v1.41h4.246l-.73 3.987h-3.516V38C33.012 37.22 38 31.719 38 25.048"
            })
        ]
    });
/* harmony default export */ var facebookIcon = (FacebookIcon);

;// CONCATENATED MODULE: ./src/components/severalbrands/footer/icons/instagramIcon.tsx


const InstagramIcon = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "42",
        height: "42",
        fill: "none",
        viewBox: "0 0 50 50",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "50",
                height: "50",
                fill: "#36387D",
                rx: "8"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#clip0_2947_4128)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#fff",
                    d: "M25 12c-3.53 0-3.973.015-5.36.079-1.383.063-2.328.282-3.155.603a6.4 6.4 0 0 0-2.302 1.5 6.4 6.4 0 0 0-1.5 2.302c-.323.827-.542 1.772-.605 3.156C12.016 21.026 12 21.47 12 25s.016 3.973.079 5.36c.063 1.383.282 2.328.603 3.154a6.4 6.4 0 0 0 1.5 2.303 6.4 6.4 0 0 0 2.302 1.5c.827.322 1.772.541 3.156.605 1.386.063 1.829.078 5.36.078 3.53 0 3.972-.015 5.358-.078 1.384-.064 2.33-.283 3.157-.604a6.4 6.4 0 0 0 2.301-1.5 6.4 6.4 0 0 0 1.5-2.303c.32-.827.54-1.772.605-3.156.062-1.386.078-1.828.078-5.359s-.016-3.974-.078-5.36c-.065-1.384-.285-2.329-.604-3.155a6.4 6.4 0 0 0-1.5-2.303 6.35 6.35 0 0 0-2.303-1.5c-.828-.321-1.774-.54-3.158-.604-1.386-.063-1.828-.078-5.36-.078zm-1.165 2.343H25c3.47 0 3.882.012 5.253.075 1.267.057 1.955.27 2.413.447a4 4 0 0 1 1.494.973c.455.455.737.888.973 1.495.178.457.39 1.145.448 2.413.062 1.37.076 1.782.076 5.251s-.014 3.881-.076 5.252c-.058 1.267-.27 1.955-.448 2.413a4 4 0 0 1-.973 1.493 4 4 0 0 1-1.494.972c-.457.18-1.146.39-2.413.448-1.37.063-1.782.076-5.253.076s-3.883-.013-5.253-.076c-1.268-.058-1.956-.27-2.414-.448a4 4 0 0 1-1.495-.972 4 4 0 0 1-.973-1.494c-.178-.458-.39-1.146-.447-2.413-.063-1.37-.075-1.783-.075-5.254 0-3.472.012-3.881.075-5.252.057-1.267.27-1.955.447-2.413.236-.607.518-1.04.973-1.495a4 4 0 0 1 1.495-.973c.458-.179 1.146-.39 2.414-.448 1.2-.055 1.664-.07 4.087-.074zM31.94 16.5a1.56 1.56 0 1 0 0 3.12 1.56 1.56 0 0 0 0-3.12M25 18.324a6.676 6.676 0 1 0 .002 13.353A6.676 6.676 0 0 0 25 18.324m0 2.343a4.333 4.333 0 1 1 0 8.666 4.333 4.333 0 0 1 0-8.666"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_2947_4128",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M12 12h26v26H12z"
                    })
                })
            })
        ]
    });
/* harmony default export */ var instagramIcon = (InstagramIcon);

;// CONCATENATED MODULE: ./src/components/severalbrands/footer/icons/linkedinIcon.tsx


const LinkedinIcon = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "42",
        height: "42",
        fill: "none",
        viewBox: "0 0 50 50",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "50",
                height: "50",
                fill: "#36387D",
                rx: "8"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#clip0_2947_4135)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#fff",
                    d: "M36.143 12c.986 0 1.857.87 1.857 1.915v22.228C38 37.187 37.13 38 36.143 38H13.799C12.813 38 12 37.188 12 36.143V13.915c0-1.044.813-1.915 1.8-1.915zM19.835 34.286V21.924h-3.83v12.362zM17.92 20.183a2.204 2.204 0 0 0 2.205-2.205c0-1.22-.987-2.264-2.205-2.264a2.266 2.266 0 0 0-2.264 2.264c0 1.218.987 2.205 2.264 2.205m16.366 14.103v-6.79c0-3.308-.755-5.92-4.643-5.92-1.857 0-3.134 1.044-3.656 2.031h-.058v-1.683h-3.657v12.362h3.83v-6.094c0-1.625.29-3.192 2.322-3.192 1.973 0 1.973 1.857 1.973 3.25v6.036z"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_2947_4135",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M12 12h26v26H12z"
                    })
                })
            })
        ]
    });
/* harmony default export */ var linkedinIcon = (LinkedinIcon);

;// CONCATENATED MODULE: ./src/components/severalbrands/footer/icons/youtubeIcon.tsx


const YoutubeIcon = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "42",
        height: "42",
        fill: "none",
        viewBox: "0 0 50 50",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "50",
                height: "50",
                fill: "#36387D",
                rx: "8"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                d: "M40.298 17.336C41 19.793 41 25.058 41 25.058s0 5.207-.702 7.722c-.351 1.404-1.462 2.457-2.808 2.808-2.516.644-12.46.644-12.46.644s-10.004 0-12.52-.644c-1.345-.35-2.457-1.404-2.808-2.808C9 30.265 9 25.058 9 25.058s0-5.265.702-7.722c.351-1.404 1.463-2.515 2.808-2.866 2.516-.702 12.52-.702 12.52-.702s9.944 0 12.46.702c1.346.35 2.457 1.462 2.808 2.866m-18.545 12.46 8.307-4.738-8.307-4.738z"
            })
        ]
    });
/* harmony default export */ var youtubeIcon = (YoutubeIcon);

// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs + 111 modules
var motion = __webpack_require__(76265);
// EXTERNAL MODULE: ./src/components/severalbrands/footer/style.module.scss
var footer_style_module = __webpack_require__(70181);
var footer_style_module_default = /*#__PURE__*/__webpack_require__.n(footer_style_module);
;// CONCATENATED MODULE: ./src/components/severalbrands/footer/index.tsx





// import TwitterIcon from "./icons/twitterIcon";




const socialLinks = [
    {
        name: "facebook",
        url: "https://www.facebook.com/profile.php?id=61570926260226",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(facebookIcon, {})
    },
    // {
    //     name: "twitter",
    //     url: "https://twitter.com/Several_brands",
    //     icon: <TwitterIcon />,
    // },
    {
        name: "instagram",
        url: "https://www.instagram.com/official_severalbrands/",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(instagramIcon, {})
    },
    {
        name: "linkedin",
        url: "https://www.linkedin.com/company/severalbrands/",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(linkedinIcon, {})
    },
    {
        name: "youtube",
        url: "https://www.youtube.com/@SeveralBrands",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(youtubeIcon, {})
    }, 
];
function SeveralBrandsFooter({ domain , contentListExist =false , hideLinks =false  }) {
    const footerLinksCol1 = domain?.menus ? domain?.menus?.find((menu)=>menu.slug === "severalbrands-footer-col-1")?.links : domain?.menusList?.find((menu)=>menu.slug === "severalbrands-footer-col-1")?.items;
    const footerLinksCol2 = domain?.menus ? domain?.menus?.find((menu)=>menu.slug === "severalbrands-footer-col-2")?.links : domain?.menusList?.find((menu)=>menu.slug === "severalbrands-footer-col-2")?.items;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("footer", {
        className: `${(footer_style_module_default()).bgStyle} `,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: `  flex   flex-col  max-w-7xl  3xl:max-w-[120rem] mx-auto px-5 3xl:pt-36 pt-20 ${contentListExist ? "3xl:pb-24 pb-[100px]" : "3xl:pb-24 pb-12"}   gap-12 lg:gap-6`,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(motion/* motion.div */.E.div, {
                    transition: {
                        duration: 1.5
                    },
                    initial: {
                        opacity: 0,
                        y: 150
                    },
                    whileInView: {
                        opacity: 1,
                        y: 0
                    },
                    viewport: {
                        once: true
                    },
                    className: " flex flex-col lg:flex-row justify-between gap-5 lg:gap-0",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mx-auto lg:mx-0 w-[206px] h-[31px] 3xl:w-[306px] 3xl:h-[61px] relative",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(footerLogo, {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-center lg:text-left lg:ml-7 mt-3 lg:max-w-[500px] 3xl:max-w-[700px] 3xl:text-xl 3xl:leading-8 font-light text-sm lg:text-base",
                                    children: "Fueling Growth With High-Intent, Performance-Based Leads."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "lg:ml-7 mt-12 lg:mt-5 lg:max-w-[500px] 3xl:max-w-[700px] 3xl:text-xl 3xl:leading-8 font-light text-sm lg:text-base",
                                    children: "Several Brands, LLC, is a performance-based digital marketing agency serving legal, auto, technology, and home services clients across the US."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: `lg:mt-5 flex flex-wrap  lg:justify-end lg:flex-nowrap   lg:gap-28 gap-8 text-sm   lg:mx-0`,
                            children: !hideLinks && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                            children: footerLinksCol1?.map((lnk, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    className: "pb-1 text-sm lg:text-base 3xl:text-xl first-of-type:font-bold first-of-type:text-[#37367D] first-of-type:text-base first-of-type:lg:text-lg first-of-type:3xl:text-2xl font-light first-of-type:mb-2",
                                                    children: index === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        children: lnk?.title
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: lnk?.link,
                                                        className: `  
                                                inline-block mb-1 `,
                                                        children: lnk?.title
                                                    })
                                                }, lnk.link))
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                            children: footerLinksCol2?.map((lnk, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    className: "pb-1 text-sm lg:text-base 3xl:text-xl first-of-type:font-bold first-of-type:text-[#37367D] first-of-type:text-base first-of-type:lg:text-lg first-of-type:3xl:text-2xl font-light first-of-type:mb-2",
                                                    children: index === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        children: lnk?.title
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: lnk?.link,
                                                        className: `  
                                                inline-block mb-1 `,
                                                        children: lnk?.title
                                                    })
                                                }, lnk.link))
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(motion/* motion.div */.E.div, {
                    transition: {
                        duration: 1.5
                    },
                    initial: {
                        opacity: 0,
                        y: 150
                    },
                    whileInView: {
                        opacity: 1,
                        y: 0
                    },
                    viewport: {
                        once: true
                    },
                    className: " flex lg:justify-between flex-col lg:flex-row gap-3 lg:gap-0",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: " lg:ml-7 flex gap-2",
                            children: socialLinks?.map((lnk)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: lnk.url,
                                    target: "_blank",
                                    rel: "noreferrer",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: " cursor-pointer block relative ",
                                        children: lnk.icon
                                    })
                                }, lnk.name))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "3xl:text-xl 3xl:leading-8 font-light text-sm lg:text-base",
                            children: [
                                "\xa9 ",
                                new Date().getFullYear(),
                                " Severalbrands.com. All Rights Reserved"
                            ]
                        })
                    ]
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./node_modules/react-google-recaptcha-v3/dist/react-google-recaptcha-v3.esm.js
var react_google_recaptcha_v3_esm = __webpack_require__(50259);
// EXTERNAL MODULE: ./src/hooks/useDomainContext.tsx
var useDomainContext = __webpack_require__(88737);
;// CONCATENATED MODULE: ./src/components/layouts/severalBrandsWrapper.tsx
/* provided dependency */ var process = __webpack_require__(83454);









function SeveralBrandsWrapper({ children , domainInfo , hideHeader =false , contentListExist =false  }) {
    // Server pages expose visitDetails with a trafficSource; static / GraphQL
    // pages don't, so visitDetails is undefined and menus stay as-is.
    const { visitDetails  } = (0,useDomainContext/* useDomainContext */.w)();
    const hasTrafficSource = Boolean(visitDetails?.trafficSource && visitDetails?.trafficSource !== "organic");
    (0,react.useEffect)(()=>{
        const targetId = window.location.hash.substring(1);
        if (targetId === "testimonials") {
            const targetElement = document.getElementById("testimonials-1");
            if (targetElement) {
                setTimeout(()=>{
                    targetElement.scrollIntoView({
                        behavior: "smooth"
                    });
                }, 0);
            }
        }
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preconnect",
                        href: "https://fonts.googleapis.com",
                        className: "jsx-7fdf6490e086a2e8"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preconnect",
                        href: "https://fonts.gstatic.com",
                        className: "jsx-7fdf6490e086a2e8"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        href: "https://fonts.googleapis.com/css2?family=Lexend+Deca:wght@100..900&display=swap",
                        rel: "stylesheet",
                        className: "jsx-7fdf6490e086a2e8"
                    })
                ]
            }),
            (0,jsx_runtime.jsx)((style_default()), {
                id: "7fdf6490e086a2e8",
                children: "body{overflow-x:unset}"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_google_recaptcha_v3_esm/* GoogleReCaptchaProvider */.pm, {
                reCaptchaKey: domainInfo?.recaptchaConfig?.key ?? process.env.NEXT_PUBLIC_SEVERAL_BRANDS_GOOGLE_RECAPTCHA_SITE_KEY,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    style: {
                        fontFamily: `'Lexend Deca', sans-serif`
                    },
                    className: "jsx-7fdf6490e086a2e8",
                    children: [
                        !hideHeader && /*#__PURE__*/ (0,jsx_runtime.jsx)(SeveralBrandsHeader, {
                            domain: domainInfo,
                            hideMenu: hasTrafficSource
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                            className: "jsx-7fdf6490e086a2e8" + " " + "max-w-7xl 3xl:max-w-[120rem] mx-auto block px-4vw lg:px-4",
                            children: children
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SeveralBrandsFooter, {
                            domain: domainInfo,
                            contentListExist: contentListExist,
                            hideLinks: hasTrafficSource
                        })
                    ]
                })
            })
        ]
    });
}


/***/ }),

/***/ 66405:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ MetaTags; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);




const domainName = "severalbrands.com";
function MetaTags(props) {
    const { title , description , image , keyWords , url , type , noIndex =false ,  } = props;
    const query = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: title ?? domainName
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: `https://${domainName}${url ? url.replace("index", "") : query.asPath.replace("index", "")}`
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "title",
                content: title ?? domainName
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: description ?? domainName
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "keywords",
                content: keyWords ?? domainName
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "viewport",
                content: "width=device-width, initial-scale=1, shrink-to-fit=no"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                httpEquiv: "x-ua-compatible",
                content: "ie=edge"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "MobileOptimized",
                content: "width"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "HandheldFriendly",
                content: "true"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "referrer",
                content: "origin"
            }),
            noIndex && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "Robots",
                content: "noindex,nofollow"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "rights",
                content: `©${new Date().getFullYear()} SeveralBrands.com. All rights reserved.`
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                itemProp: "name",
                content: title ?? domainName
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                itemProp: "description",
                content: description ?? domainName
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                itemProp: "image",
                content: image ?? ""
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: type ?? "website"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: title ?? domainName
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: `https://${domainName}${url ? url : query.asPath}`
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: description ?? ""
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: image ?? ""
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:url",
                content: image ?? ""
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:site_name",
                content: "SeveralBrands.com"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:locale",
                content: "en"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "twitter:card",
                content: "summary_large_image"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "twitter:url",
                content: `https://${domainName}${url ? url : query.asPath}`
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "twitter:title",
                content: title ?? domainName
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "twitter:description",
                content: description ?? domainName
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "twitter:image",
                content: image ?? ""
            })
        ]
    });
}


/***/ }),

/***/ 91173:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

const useWindowSize = ()=>{
    const { 0: windowSize , 1: setWindowSize  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
        width: 0,
        height: 0
    });
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        const handleResize = ()=>{
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight
            });
        };
        window.addEventListener("resize", handleResize);
        handleResize();
        return ()=>window.removeEventListener("resize", handleResize);
    }, []);
    return windowSize;
};
/* harmony default export */ __webpack_exports__["Z"] = (useWindowSize);


/***/ }),

/***/ 70181:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"bgStyle":"style_bgStyle__IUa0I"};

/***/ }),

/***/ 66257:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"menuItem":"style_menuItem__Rd1Lg","allMenu":"style_allMenu__VPX_q","innerDiv":"style_innerDiv__2H9VS","menu":"style_menu__xS9JI","open":"style_open__l5iO4","burger":"style_burger__DqdHl","openBurger":"style_openBurger__8S_Xx","stickyStyle":"style_stickyStyle__2e3ZE","stickyStyleAfter":"style_stickyStyleAfter__RD1L3"};

/***/ })

}]);